import styled from 'styled-components';

const Wrap = styled.div`
  font-size: ${({ theme }) => theme.fontClamp?.sm || '0.875rem'};
  color: ${({ theme }) => theme.colors.mutedForeground};
  line-height: 1.7;

  h2,
  h3 {
    color: ${({ theme }) => theme.colors.foreground};
    margin: 1.25rem 0 0.5rem;
    line-height: 1.3;
  }

  h2 {
    font-size: ${({ theme }) => theme.fontClamp?.lg || '1.125rem'};
  }

  h3 {
    font-size: ${({ theme }) => theme.fontClamp?.md || '1rem'};
  }

  p {
    margin: 0 0 0.75rem;
  }

  ul,
  ol {
    margin: 0 0 0.75rem;
    padding-left: 1.25rem;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0 0 1rem;
    font-size: 0.8125rem;
  }

  th,
  td {
    border: 1px solid ${({ theme }) => theme.colors.border};
    padding: 0.5rem 0.625rem;
    text-align: left;
  }

  img {
    max-width: 100%;
    height: auto;
    border-radius: ${({ theme }) => theme.radiusSm || '8px'};
  }

  details[data-faq] {
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.radiusSm || '8px'};
    background: ${({ theme }) => theme.colors.card};
    margin: 0 0 0.625rem;
    overflow: hidden;
  }

  details[data-faq] > summary {
    cursor: pointer;
    list-style: none;
    padding: 0.75rem 0.875rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.foreground};
  }

  details[data-faq] > summary::-webkit-details-marker {
    display: none;
  }

  details[data-faq] > summary::before {
    content: '+';
    display: inline-block;
    width: 1rem;
    margin-right: 0.5rem;
    color: ${({ theme }) => theme.colors.primary};
  }

  details[data-faq][open] > summary::before {
    content: '−';
  }

  details[data-faq] > div[data-faq-answer] {
    padding: 0 0.875rem 0.875rem;
    color: ${({ theme }) => theme.colors.mutedForeground};
  }
`;

export default function RichContent({ html, className, ...rest }) {
  if (!html) return null;
  return <Wrap className={className} dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
}
